import { useLocation } from 'react-router-dom';

// Get the prefix of the API endpoint according to the current path
const useService = () => {
  const { pathname } = useLocation();

  if (pathname.startsWith(process.env.PUBLIC_URL + '/trademarkRights')) {
    return process.env.PUBLIC_URL + '/trademarkRights'; // 商標 API 前半段
  }

  if (pathname.startsWith(process.env.PUBLIC_URL + '/patentRights')) {
    return process.env.PUBLIC_URL + '/patentRights'; // 專利 API 前半段
  }

  if (pathname.startsWith(process.env.PUBLIC_URL + '/certificate')) {
    return process.env.PUBLIC_URL + '/certificate'; // 電子證書
  }

  return '/not-found';
};

export default useService;
